// extracted by mini-css-extract-plugin
export default {"vertical":"PlusToMinus_vertical__3LroC","horizontal":"PlusToMinus_horizontal__2RCpj","root":"PlusToMinus_root__h5hAo","open":"PlusToMinus_open__1CJKg"};